import $ from "jquery";
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/disable-selection';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/sortable';

$(document).on('before_submit', 'form', function (e) {
    $('.ui-sortable', this).each(function () {
        var $this = $(this);
        if ($this.attr('data-input-target')) {
            $($this.attr('data-input-target')).val($this.sortable('serialize'));
        }
    });
});

export function initialize(context) {
    if (!$('.sortable', context).length) {
        return;
    }

    // Initiate sortable on connected lists
    var $groups = [];
    $('.sortable[data-sortable-group]:not(.ui-sortable)', context).each(function () {
        $groups.push($(this).attr('data-sortable-group'));
    });

    $($groups.unique(), context).each(function (i, group) {
        var $group = $('.sortable[data-sortable-group="' + group + '"]:not(.ui-sortable)', context),
            handle = $group.attr('data-sortable-handle'),
            options = {
                connectWith: $group,
                out: function (e, ui) {
                    $(e.target).removeClass('sortable-dropping');
                },
                over: function (e, ui) {
                    $(e.target).addClass('sortable-dropping');
                },
                stop: function (e, ui) {
                    /*var minHeight = 20;
                    $group.css({ 'min-height': 0 }).each(function () {
                        minHeight = Math.max(minHeight, $(this).outerHeight());
                    });
                    $group.css({ 'min-height': minHeight });*/
                },
                containment: $group.attr('data-containment') ? $group.attr('data-containment') : false
            };
        if (handle) {
            options.handle = handle;
        }
        $group.sortable(options);

        if ($group.filter('[disabled]').length) {
            $group.sortable('disable');
        }

        setTimeout(function () {
            $group.disableSelection().sortable('option', 'stop')();
        }, 100);
    });

    // Initiate sortable on table rows
    var tables = $('table.sortable tbody', context).sortable({
        forcePlaceholderSize: true,
        handle: '.handle',
        start: function (e, ui) {
            $(ui.placeholder).height($(ui.item).height());
        },
        helper: function (e, ui) {
            ui.children().each(function () {
                var $this = $(this);
                $this.width($this.width());
            });
            return ui;
        },
        stop: function (e, ui) {
            $(ui.item).find('td').css({ width: 'auto', height: 'auto' });
        }
    });
    var disabledTables = $('table.sortable[disabled] tbody');
    if (disabledTables.length) {
        disabledTables.sortable('disable');
    }


    //head.load(['//code.jquery.com/ui/1.11.4/themes/smoothness/jquery-ui.css'], function () {
        
    //});
}


export default { initialize };
